/*  global Cookies */

const ruleOwnBrand = (documentUrl, documentReferrer, utmMap) => {
    if (utmMap.utm_medium === 'organic' && ['blank', null, undefined].indexOf(utmMap.utm_campaign) > -1 && utmMap.utm_term.split('mi-cuenta').length > 1) {
        utmMap.utm_campaign = 'MiCuenta';
    } else if (utmMap.utm_medium === 'organic' && ['blank', null, undefined].indexOf(utmMap.utm_campaign) > -1) {
        utmMap.utm_campaign = 'OwnBrand';
    }
    return utmMap;
};

const ruleCrm = (documentUrl, documentReferrer, utmMap) => {
    const regex = /\/(buffalo|komodo|raccoon)\//;
    if (regex.test(documentUrl)) {
        utmMap.utm_campaign = 'CRM';
    }
    return utmMap;
};

const uriSearch = (url) => {
    const uri = new URLSearchParams(new URL(url).search);
    const map = {};
    for (const [key, value] of uri) {
        map[key] = value;
    }
    return map;
};

const uriHost = (url) => {
    return new URL(url).host;
};

const uriPath = (url) => {
    return new URL(url).pathname;
};

export const Tracking = (configuration) => {
    /*
        @param configuration: un diccionario compuesto por los siguientes parámetros:
            w: string: El valor del parametro w que se pasara por la url
            button_selector: string: un string que indica el selector de los botones,
    */
    let config = {
        w: '',
        document_url: document.location.href,
        my_host: uriHost(document.location.href),
        referrer: document.referrer,
        default_utms: {},
        name_start: 'ceca_',
        domain: window.location.hostname.replace('www.', '').replace('local.', '')
    };

    const rules = [
        ruleOwnBrand,
        ruleCrm
    ];

    const extend = (destination, source) => {
        return { ...destination, ...source };
    };

    config = extend(config, configuration);

    const applyRules = (documentUrl, documentReferrer, utmMap) => {
        for (let i = 0; i < rules.length; i++) {
            utmMap = rules[i](documentUrl, documentReferrer, utmMap);
        }
        return utmMap;
    };

    const cookie = (name) => {
        const val = Cookies.get(name);
        if (val) {
            return decodeURIComponent(escape(atob(val)));
        }
        return val;
    };

    const getAnalysis = (referrer) => {
        const mapAnalysis = {};
        const host = uriHost(referrer);

        if (host.split('google').length >= 2) {
            mapAnalysis.utm_source = 'google';
            mapAnalysis.utm_medium = 'organic';
        } else if (host.split('bing').length >= 2) {
            mapAnalysis.utm_source = 'bing';
            mapAnalysis.utm_medium = 'organic';
        } else if (host.split('yahoo').length >= 2) {
            mapAnalysis.utm_source = 'yahoo';
            mapAnalysis.utm_medium = 'organic';
        } else if (host.split('gadwords').length >= 2) {
            mapAnalysis.utm_source = 'gadwords';
            mapAnalysis.utm_medium = 'cpc';
        } else {
            mapAnalysis.utm_source = host;
            mapAnalysis.utm_medium = 'organic';
        }
        return mapAnalysis;
    };

    const trackInfo = () => {
        /*
            Retorna la información que se desea trackear
            @param stringMode indica de que forma se retorna la información indicada, es decir si es o no
                compatible con la url.
            @returns un string con la informacion indicada
        */
        let data = {};
        const mapUrl = uriSearch(config.document_url);
        let mapAnalysis = {};
        const referrer = mapUrl.ref || config.referrer;
        let termQ = null;
        const hasQuery = mapUrl.utm_source || mapUrl.utm_campaign || mapUrl.utm_medium;
        const hasAdwordMark = uriSearch(config.document_url).gclid !== undefined;
        const hasCookie = cookie('ceca_utm_source') || cookie('ceca_utm_campaign') || cookie('ceca_utm_medium');
        const hasAnalysis = !hasQuery && config.referrer;

        // Si no tiene utms seteados y el referer es un buscador, lo marcamos como organic
        if (hasAnalysis) {
            mapAnalysis = getAnalysis(referrer);
        }

        if (referrer) {
            termQ = uriSearch(config.referrer).q;
        }

        if (hasQuery) {
            data.utm_source = mapUrl.utm_source;
            data.utm_campaign = mapUrl.utm_campaign;
            data.utm_medium = mapUrl.utm_medium;
            data.utm_content = mapUrl.utm_content;
            data.utm_term = mapUrl.utm_term;
        } else if (hasCookie) {
            data.utm_source = cookie('ceca_utm_source');
            data.utm_campaign = cookie('ceca_utm_campaign');
            data.utm_medium = cookie('ceca_utm_medium');
            data.utm_content = cookie('ceca_utm_content');
            data.utm_term = cookie('ceca_utm_term');
        } else if (hasAdwordMark) {
            data.utm_source = 'gadwords';
            data.utm_campaign = 'unset';
            data.utm_medium = 'cpc';
            data.utm_content = 'unset';
            data.utm_term = 'unset';
        } else if (hasAnalysis) {
            data.utm_source = mapAnalysis.utm_source;
            data.utm_campaign = mapAnalysis.utm_campaign || config.default_utms.utm_campaign;
            data.utm_medium = mapAnalysis.utm_medium;
            data.utm_content = mapAnalysis.utm_content || config.default_utms.utm_content;
            data.utm_term = mapAnalysis.utm_term || termQ || config.default_utms.utm_term;
        } else {
            data.utm_source = config.default_utms.utm_source;
            data.utm_campaign = config.default_utms.utm_campaign;
            data.utm_medium = config.default_utms.utm_medium;
            data.utm_content = config.default_utms.utm_content;
            data.utm_term = config.default_utms.utm_term;
        }
        // Set Term
        data.ref = referrer;

        if (!data.utm_term) {
            data.utm_term = uriPath(config.document_url) + '|';
        } else if (decodeURIComponent(data.utm_term).split('|').length === 1) {
            data.utm_term = uriPath(config.document_url) + '|' + data.utm_term;
        }

        data = applyRules(config.document_url, referrer, data);

        for (const k in data) {
            if (data[k]) {
                if (config.domain !== null) {
                    Cookies.set(config.name_start + k,
                        btoa(unescape(encodeURIComponent(data[k]))),
                        { domain: config.domain });
                } else {
                    Cookies.set(config.name_start + k,
                        btoa(unescape(encodeURIComponent(data[k]))));
                }
            }
        }
        return data;
    };

    return trackInfo();
};
